import { VerifiedBadge } from './VerifiedBadge';

export { VerifiedBadge };
